import type { WalkthroughConfig } from "../types";

export const signatureEventsWalkthrough: WalkthroughConfig = {
  id: "page-signature-events",
  title: "Signature Events",
  description: "Plan and execute your organization's flagship events with a full workspace.",
  type: "page",
  pageRoute: "/signature-events",
  duration: "1 min",
  category: "pages",
  icon: "Crown",
  steps: [
    {
      id: "intro",
      title: "Signature Events",
      description:
        "Signature Events are your organization's flagship experiences — annual galas, conferences, and major fundraisers that deserve dedicated planning workspaces.",
      placement: "center",
      animation: "fade",
      icon: "Crown",
    },
    {
      id: "workspace",
      title: "Full Planning Workspace",
      description:
        "Each signature event gets its own workspace with budgets, sponsors, vendors, run-of-show, logistics, and linked public registration.",
      placement: "center",
      animation: "slide-up",
      icon: "ClipboardList",
    },
    {
      id: "sponsors",
      title: "Sponsor & Vendor Management",
      description:
        "Track sponsor commitments, vendor contracts, and fulfillment obligations. Keep all stakeholders organized in one place.",
      placement: "center",
      animation: "fade",
      icon: "Handshake",
    },
    {
      id: "execution",
      title: "Event-Day Execution",
      description:
        "Build run-of-show timelines, track logistics, and execute flawlessly on event day with real-time checklists and status tracking.",
      placement: "center",
      animation: "scale",
      icon: "Target",
      nextLabel: "Got it! ✓",
    },
  ],
};
